import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { CarrierContext } from "../contexts/CarrierContext";

export default function PrivateRoute({ Component }) {
  const carrierContxt = useContext(CarrierContext);
  const urlCarrier = carrierContxt.hasOwnProperty("carrier")
    ? carrierContxt.carrier
    : null;
  const carr_code = "REACT_APP_" + urlCarrier.toUpperCase();
  const isAuthenticated = sessionStorage.getItem(
    "userData_" + process.env[carr_code]
  );

  return isAuthenticated ? Component : <Navigate to={`/${urlCarrier}`} />;
}
